<template>
  <footer id="section__footer" class="padding__base">
    <div class="about-info">
      <v-row
        class="d-flex align-center justify-space-between flex-nowrap"
        style="flex-wrap: nowrap; overflow-x: auto"
      >
        <div class="logo__esr">
          <svg
            class="responsive-svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 248.525 80.072"
            width="140"
          >
            <g id="Logo_ESR" transform="translate(-7.675 -9.618)">
              <g id="Grupo_73" data-name="Grupo 73">
                <path
                  id="Trazado_110"
                  data-name="Trazado 110"
                  d="M70.4,19.5a55.769,55.769,0,0,0-24.2,12A60.366,60.366,0,0,0,36.4,41L61,34,49.8,32.4a48.512,48.512,0,0,1,11.9-5.1C83,21.7,92.6,30.2,90.6,43.5h0C88.1,60.3,71.7,78.8,44.8,84.2,22.3,88.8,5.5,79.1,8,62.3H8C4.9,82.6,24.3,94.1,51.2,88.1s51.3-27.3,54.3-47.5h0C108.1,23.8,92.8,14.5,70.4,19.5Z"
                ></path>
                <path
                  id="Trazado_111"
                  data-name="Trazado 111"
                  d="M46.4,79.8A56.736,56.736,0,0,0,70.6,67.9a60.366,60.366,0,0,0,9.8-9.5l-24.6,7L67,67a48.512,48.512,0,0,1-11.9,5.1c-21.3,5.6-31-2.9-28.9-16.2h0C28.7,39,45.1,20.6,72,15.1c22.5-4.6,39.3,5.1,36.8,21.9h0c3.1-20.2-16.3-31.8-43.2-25.8S14.4,38.5,11.3,58.7h0C8.7,75.5,24,84.8,46.4,79.8Z"
                ></path>
                <path
                  id="Trazado_112"
                  data-name="Trazado 112"
                  d="M45.5,45.8l-.4,2.4h4.2l-.5,3.2H44.6l-.4,2.4h4.4L48.1,57H39.9l2.3-14.4h8.2l-.5,3.2Z"
                ></path>
                <path
                  id="Trazado_113"
                  data-name="Trazado 113"
                  d="M60.1,46.3a3.255,3.255,0,0,0-2.3-1c-.7,0-1.7.4-1.8,1.2s.8,1.2,1.4,1.4l.9.3c1.9.6,3.3,1.6,2.9,3.9A5.86,5.86,0,0,1,59.1,56a7.119,7.119,0,0,1-4.3,1.4A7.913,7.913,0,0,1,50,55.8l2.1-3a4.389,4.389,0,0,0,3.1,1.5,1.949,1.949,0,0,0,2.1-1.5c.2-1.1-1.3-1.4-2-1.6C53,50.5,51.5,49.8,52,47a5.725,5.725,0,0,1,5.8-4.8,8.636,8.636,0,0,1,4.3,1.2Z"
                ></path>
                <path
                  id="Trazado_114"
                  data-name="Trazado 114"
                  d="M74.3,57H69.6L67,51.5h0L66,57H62.2l2.3-14.4h5.6c2.9,0,4.8,1.4,4.3,4.4a4.778,4.778,0,0,1-3.8,4.1L74.3,57m-7-7.9h.4c1.2,0,2.6-.2,2.9-1.8s-1.1-1.8-2.3-1.8h-.4Z"
                ></path>
                <path
                  id="Trazado_115"
                  data-name="Trazado 115"
                  d="M45.5,45.8l-.4,2.4h4.2l-.5,3.2H44.6l-.4,2.4h4.4L48.1,57H39.9l2.3-14.4h8.2l-.5,3.2Z"
                ></path>
                <path
                  id="Trazado_116"
                  data-name="Trazado 116"
                  d="M60.1,46.3a3.255,3.255,0,0,0-2.3-1c-.7,0-1.7.4-1.8,1.2s.8,1.2,1.4,1.4l.9.3c1.9.6,3.3,1.6,2.9,3.9A5.86,5.86,0,0,1,59.1,56a7.119,7.119,0,0,1-4.3,1.4A7.913,7.913,0,0,1,50,55.8l2.1-3a4.389,4.389,0,0,0,3.1,1.5,1.949,1.949,0,0,0,2.1-1.5c.2-1.1-1.3-1.4-2-1.6C53,50.5,51.5,49.8,52,47a5.725,5.725,0,0,1,5.8-4.8,8.636,8.636,0,0,1,4.3,1.2Z"
                ></path>
                <path
                  id="Trazado_117"
                  data-name="Trazado 117"
                  d="M74.3,57H69.6L67,51.5h0L66,57H62.2l2.3-14.4h5.6c2.9,0,4.8,1.4,4.3,4.4a4.778,4.778,0,0,1-3.8,4.1L74.3,57m-7-7.9h.4c1.2,0,2.6-.2,2.9-1.8s-1.1-1.8-2.3-1.8h-.4Z"
                ></path>
                <path
                  id="Trazado_118"
                  data-name="Trazado 118"
                  d="M125.7,29.3l-.4,2.5h4.4l-.5,3.3h-4.4l-.4,2.6H129l-.5,3.3H120l2.4-14.8h8.5l-.5,3.3h-4.7Z"
                ></path>
                <path
                  id="Trazado_119"
                  data-name="Trazado 119"
                  d="M145.9,24.7l1.2,16.2h-2.5l-.7-9.5-5.8,10.5L135,31.4l-3,9.5h-2.3L134.8,25l3.8,12.1Z"
                ></path>
                <path
                  id="Trazado_120"
                  data-name="Trazado 120"
                  d="M151.7,26.1h3a5.129,5.129,0,0,1,3,.7,3.738,3.738,0,0,1,1.3,1.5,5.374,5.374,0,0,1,.5,2.1,4.47,4.47,0,0,1-.9,2.8,4.908,4.908,0,0,1-4.2,1.8h-1.6l-.7,6h-2.2Zm2.1,2.1-.6,4.8h1.4a2.817,2.817,0,0,0,2.1-.7,2.578,2.578,0,0,0,.7-2q0-2.1-2.7-2.1h-.9Z"
                ></path>
                <path
                  id="Trazado_121"
                  data-name="Trazado 121"
                  d="M166.7,34.6l3.7,6.3h-2.3l-3.5-6.1h-.8l-.7,6.1h-2.2l1.8-14.8h2.9a7.117,7.117,0,0,1,2.3.3,4.194,4.194,0,0,1,1.4.9,4.143,4.143,0,0,1,1.2,3.1C170.5,32.6,169.2,34,166.7,34.6Zm-2-6.4-.6,4.8h1a7.18,7.18,0,0,0,1.7-.2,2.286,2.286,0,0,0,1-.7,2.458,2.458,0,0,0,.5-1.7,1.651,1.651,0,0,0-.7-1.6,3.439,3.439,0,0,0-2-.5h-.9Z"
                ></path>
                <path
                  id="Trazado_122"
                  data-name="Trazado 122"
                  d="M182.2,26.1l-.2,2.1h-5.5l-.5,3.7h5.5l-.2,1.9h-5.5l-.6,4.9h5.5l-.3,2.1H173L174.6,26h7.6Z"
                ></path>
                <path
                  id="Trazado_123"
                  data-name="Trazado 123"
                  d="M192.7,28.3l-1.5,1.4a2.955,2.955,0,0,0-2.4-1.5,2.111,2.111,0,0,0-1.6.6,1.974,1.974,0,0,0-.6,1.4,1.594,1.594,0,0,0,.4,1.2,4.233,4.233,0,0,0,.7.5c.3.2.6.4,1.1.7a8.674,8.674,0,0,1,2.6,1.9,3.928,3.928,0,0,1,.7,2.3,4.07,4.07,0,0,1-1.2,3,4.411,4.411,0,0,1-3.3,1.1,5.073,5.073,0,0,1-2.8-.7,4.983,4.983,0,0,1-1.1-1,16.965,16.965,0,0,1-1-1.4l1.7-1.1a6.675,6.675,0,0,0,1.3,1.7,2.861,2.861,0,0,0,1.7.4,2.445,2.445,0,0,0,1.8-.6,2.24,2.24,0,0,0,.7-1.7,2.106,2.106,0,0,0-.5-1.3,4.349,4.349,0,0,0-.7-.6,6.348,6.348,0,0,0-1.2-.7,6.543,6.543,0,0,1-2.3-1.8,3.7,3.7,0,0,1-.6-2.1,3.631,3.631,0,0,1,1.2-2.8,4.227,4.227,0,0,1,3.1-1.1,4.648,4.648,0,0,1,2.1.5A6.747,6.747,0,0,1,192.7,28.3Z"
                ></path>
                <path
                  id="Trazado_124"
                  data-name="Trazado 124"
                  d="M197,37.4l-1.8,3.4h-2.4L201,24.9l5.1,15.9h-2.3l-1.1-3.4Zm1-1.9h4.2l-1.6-5.3Z"
                ></path>
                <path
                  id="Trazado_125"
                  data-name="Trazado 125"
                  d="M129.9,50.4a3.492,3.492,0,0,0-2.4-1,1.961,1.961,0,0,0-1.9,1.2c-.1.9.9,1.2,1.5,1.4l.9.3c2,.6,3.4,1.7,3,4.1a5.615,5.615,0,0,1-2.2,4,7.2,7.2,0,0,1-4.4,1.4,7.955,7.955,0,0,1-5-1.7l2.2-3.1a4.618,4.618,0,0,0,3.2,1.5,2.048,2.048,0,0,0,2.1-1.5c.2-1.1-1.3-1.5-2.1-1.7-2.3-.7-3.8-1.3-3.4-4.2a5.838,5.838,0,0,1,5.9-5,9.732,9.732,0,0,1,4.5,1.2Z"
                ></path>
                <path
                  id="Trazado_126"
                  data-name="Trazado 126"
                  d="M147.6,53.7a7.578,7.578,0,0,1-1.3,4.4,7.32,7.32,0,0,1-2.8,2.4,7.9,7.9,0,0,1-3.8.9,7.654,7.654,0,0,1-5.4-2,7.08,7.08,0,0,1-2.1-5.3,7.016,7.016,0,0,1,2.2-5.4,7.948,7.948,0,0,1,5.6-2.1,7.734,7.734,0,0,1,5.5,2A6.636,6.636,0,0,1,147.6,53.7Zm-2.1,0a5.308,5.308,0,0,0-1.4-3.7,5.637,5.637,0,0,0-3.9-1.4,5.925,5.925,0,0,0-4.1,1.5,5.007,5.007,0,0,0-1.7,3.8,5.2,5.2,0,0,0,1.5,3.8,5.276,5.276,0,0,0,3.9,1.5,5.577,5.577,0,0,0,4.1-1.6A4.849,4.849,0,0,0,145.5,53.7Z"
                ></path>
                <path
                  id="Trazado_127"
                  data-name="Trazado 127"
                  d="M162.1,48.2l-.3,2.4a6.287,6.287,0,0,0-4.6-2,4.777,4.777,0,0,0-3.8,1.6,5.593,5.593,0,0,0-1.5,4.1,4.975,4.975,0,0,0,1.4,3.7,5.361,5.361,0,0,0,4,1.3,5.846,5.846,0,0,0,3.8-1.3l-.3,2.6a11.266,11.266,0,0,1-3.8.8,6.71,6.71,0,0,1-7.1-7.2,8.083,8.083,0,0,1,2-5.5,6.947,6.947,0,0,1,5.3-2.2A10.308,10.308,0,0,1,162.1,48.2Z"
                ></path>
                <path
                  id="Trazado_128"
                  data-name="Trazado 128"
                  d="M167.2,46.6l-1.8,14.9h-2.1l1.8-14.9Z"
                ></path>
                <path
                  id="Trazado_129"
                  data-name="Trazado 129"
                  d="M172,58l-1.8,3.5h-2.4L176,45.6l5.1,15.9h-2.3L177.7,58Zm.9-2h4.2l-1.6-5.3Z"
                ></path>
                <path
                  id="Trazado_130"
                  data-name="Trazado 130"
                  d="M186.9,46.6l-1.6,12.7h4.2l-.3,2.1h-6.4l1.8-14.9h2.3Z"
                ></path>
                <path
                  id="Trazado_131"
                  data-name="Trazado 131"
                  d="M206.5,45.2l1.2,16.2h-2.5l-.7-9.5-5.8,10.5L195.6,52l-3,9.5h-2.3l5.1-15.9,3.8,12.1Z"
                ></path>
                <path
                  id="Trazado_132"
                  data-name="Trazado 132"
                  d="M220,46.6l-.3,2.1h-5.5l-.5,3.7h5.5l-.2,1.9h-5.5l-.6,4.9h5.5l-.3,2.1h-7.4l1.6-14.9H220Z"
                ></path>
                <path
                  id="Trazado_133"
                  data-name="Trazado 133"
                  d="M235.5,46.6l-1.9,15.9-9-11.5-1.3,10.5h-2.1l1.9-15.7,9,11.5,1.3-10.7Z"
                ></path>
                <path
                  id="Trazado_134"
                  data-name="Trazado 134"
                  d="M242.9,48.7l-1.6,12.7h-2.1l1.5-12.7h-3.5l.3-2.1h9.1l-.3,2.1Z"
                ></path>
                <path
                  id="Trazado_135"
                  data-name="Trazado 135"
                  d="M256.2,46.6l-.3,2.1h-5.5l-.5,3.7h5.5l-.2,1.9h-5.5l-.6,4.9h5.5l-.3,2.1H247l1.6-14.9h7.6Z"
                ></path>
                <path
                  id="Trazado_136"
                  data-name="Trazado 136"
                  d="M132.3,82h-4.8l-2.7-5.7h0l-.9,5.7H120l2.4-14.8h5.8c2.9,0,4.9,1.4,4.4,4.6a5,5,0,0,1-3.9,4.2Zm-7.2-8.2h.4c1.3,0,2.7-.2,3-1.8s-1.1-1.8-2.4-1.8h-.4Z"
                ></path>
                <path
                  id="Trazado_137"
                  data-name="Trazado 137"
                  d="M142.8,67.1l-.3,2.1H137l-.5,3.7H142l-.2,1.9h-5.5l-.6,4.9h5.5l-.3,2.1h-7.4L135.1,67h7.7Z"
                ></path>
                <path
                  id="Trazado_138"
                  data-name="Trazado 138"
                  d="M153.4,69.4l-1.5,1.4a2.955,2.955,0,0,0-2.4-1.5,2.111,2.111,0,0,0-1.6.6,1.974,1.974,0,0,0-.6,1.4,2.144,2.144,0,0,0,.4,1.2,4.233,4.233,0,0,0,.7.5c.3.2.6.4,1.1.7a10.841,10.841,0,0,1,2.6,1.9,3.928,3.928,0,0,1,.7,2.3,4.07,4.07,0,0,1-1.2,3,4.411,4.411,0,0,1-3.3,1.1,5.073,5.073,0,0,1-2.8-.7,9.96,9.96,0,0,1-1.1-1,16.965,16.965,0,0,1-1-1.4l1.7-1.1a6.675,6.675,0,0,0,1.3,1.7,2.86,2.86,0,0,0,1.7.5,2.445,2.445,0,0,0,1.8-.6,2.24,2.24,0,0,0,.7-1.7,2.106,2.106,0,0,0-.5-1.3,4.349,4.349,0,0,0-.7-.6,6.348,6.348,0,0,0-1.2-.7,6.543,6.543,0,0,1-2.3-1.8,3.7,3.7,0,0,1-.6-2.1,3.631,3.631,0,0,1,1.2-2.8,4.227,4.227,0,0,1,3.1-1.1,4.648,4.648,0,0,1,2.1.5A5.735,5.735,0,0,1,153.4,69.4Z"
                ></path>
                <path
                  id="Trazado_139"
                  data-name="Trazado 139"
                  d="M156.6,67.1h3a6.122,6.122,0,0,1,3,.6,3.738,3.738,0,0,1,1.3,1.5,5.374,5.374,0,0,1,.5,2.1,4.47,4.47,0,0,1-.9,2.8,4.908,4.908,0,0,1-4.2,1.8h-1.6l-.7,6h-2.2Zm2.1,2.1-.6,4.8h1.4a2.817,2.817,0,0,0,2.1-.7,2.578,2.578,0,0,0,.7-2q0-2.1-2.7-2.1h-.9Z"
                ></path>
                <path
                  id="Trazado_140"
                  data-name="Trazado 140"
                  d="M181.4,74.3a7.578,7.578,0,0,1-1.3,4.4,7.32,7.32,0,0,1-2.8,2.4,7.86,7.86,0,0,1-3.8.8,7.654,7.654,0,0,1-5.4-2,7.733,7.733,0,0,1,.1-10.7,7.948,7.948,0,0,1,5.6-2.1,7.734,7.734,0,0,1,5.5,2A6.708,6.708,0,0,1,181.4,74.3Zm-2.1-.1a5.308,5.308,0,0,0-1.4-3.7,5.637,5.637,0,0,0-3.9-1.4,5.925,5.925,0,0,0-4.1,1.5,5.007,5.007,0,0,0-1.7,3.8,5.2,5.2,0,0,0,1.5,3.8,5.276,5.276,0,0,0,3.9,1.5,5.577,5.577,0,0,0,4.1-1.6A4.717,4.717,0,0,0,179.3,74.2Z"
                ></path>
                <path
                  id="Trazado_141"
                  data-name="Trazado 141"
                  d="M197.8,67.1,195.9,83l-9-11.5L185.5,82h-2.2l1.9-15.6,9,11.5,1.3-10.7h2.3Z"
                ></path>
                <path
                  id="Trazado_142"
                  data-name="Trazado 142"
                  d="M209.1,69.4l-1.5,1.4a2.955,2.955,0,0,0-2.4-1.5,2.24,2.24,0,0,0-2.3,2,1.594,1.594,0,0,0,.4,1.2,4.233,4.233,0,0,0,.7.5c.3.2.6.4,1.1.7a10.841,10.841,0,0,1,2.6,1.9,3.928,3.928,0,0,1,.7,2.3,4.07,4.07,0,0,1-1.2,3,4.411,4.411,0,0,1-3.3,1.1,5.073,5.073,0,0,1-2.8-.7,9.96,9.96,0,0,1-1.1-1,16.965,16.965,0,0,1-1-1.4l1.7-1.1a6.675,6.675,0,0,0,1.3,1.7,2.86,2.86,0,0,0,1.7.5,2.445,2.445,0,0,0,1.8-.6,2.24,2.24,0,0,0,.7-1.7,2.106,2.106,0,0,0-.5-1.3,4.349,4.349,0,0,0-.7-.6,6.348,6.348,0,0,0-1.2-.7,6.543,6.543,0,0,1-2.3-1.8,3.7,3.7,0,0,1-.6-2.1,3.631,3.631,0,0,1,1.2-2.8,4.227,4.227,0,0,1,3.1-1.1,4.648,4.648,0,0,1,2.1.5A3.72,3.72,0,0,1,209.1,69.4Z"
                ></path>
                <path
                  id="Trazado_143"
                  data-name="Trazado 143"
                  d="M213.4,78.5l-1.8,3.4h-2.4L217.4,66l5.1,15.9h-2.3l-1.1-3.4Zm1-1.9h4.2L217,71.3Z"
                ></path>
                <path
                  id="Trazado_144"
                  data-name="Trazado 144"
                  d="M226.4,67.1h2.7a5.618,5.618,0,0,1,2,.3,3.805,3.805,0,0,1,1.3.9,3.586,3.586,0,0,1,.8,2.5,3.637,3.637,0,0,1-2.2,3.4,3.008,3.008,0,0,1,2.6,3.3,5.374,5.374,0,0,1-.5,2.1,4.428,4.428,0,0,1-1.2,1.5,3.506,3.506,0,0,1-1.4.6,2.769,2.769,0,0,1-.9.1h-5.1Zm.9,8.1-.6,4.6h1.5a4.273,4.273,0,0,0,2.3-.4,2.388,2.388,0,0,0,1-2.1,2.959,2.959,0,0,0-.2-1,1.794,1.794,0,0,0-.5-.7,1.884,1.884,0,0,0-.9-.4,5.283,5.283,0,0,0-1.3-.1h-1.3Zm.9-6-.5,4.4h.6c1.9,0,2.8-.9,2.8-2.6,0-1.2-.7-1.8-2.2-1.8Z"
                ></path>
                <path
                  id="Trazado_145"
                  data-name="Trazado 145"
                  d="M239.8,67.1l-1.6,12.7h4.2l-.2,2.1h-6.4l1.8-14.8h2.2Z"
                ></path>
                <path
                  id="Trazado_146"
                  data-name="Trazado 146"
                  d="M253.8,67.1l-.3,2.1H248l-.5,3.7H253l-.2,1.9h-5.5l-.6,4.9h5.5L252,82h-7.3l1.6-14.8h7.5Z"
                ></path>
              </g>
            </g>
          </svg>
        </div>

        <!-- Puedes agregar más elementos si tienes más cosas en el footer -->
        <div class="footer__element">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 42 41.986"
            class="responsive-svg"
            width="60"
          >
            <g
              id="_9_-_Email_1"
              data-name="9 - Email 1"
              transform="translate(0 0)"
            >
              <path
                id="Vector"
                d="M2.8,19.149,14.37,27.156l-4.9,4.918a1.395,1.395,0,1,0,1.965,1.979l5.28-5.278L20.2,31.2a1.4,1.4,0,0,0,1.59,0l3.5-2.429,5.265,5.278a1.4,1.4,0,1,0,1.98-1.979l-4.9-4.918L39.2,19.149V34.564a4.6,4.6,0,0,1-4.62,4.633H7.5a4.6,4.6,0,0,1-4.62-4.633Zm10.7-4.064a1.409,1.409,0,0,0,0,2.8h15a1.41,1.41,0,1,0,0-2.8Zm21-.645,3.54,2.129L34.5,19.029Zm-27,0v4.5L3.99,16.57ZM13.32,7.5a1.427,1.427,0,1,0,.18,2.849H21A1.424,1.424,0,1,0,21,7.5ZM26.91,5.234,30.075,9H26.91ZM12,2.805H24.165V10.5a1.41,1.41,0,0,0,1.41,1.409H31.71v9.087L21,28.341,10.335,20.994V4.5a1.574,1.574,0,0,1,.48-1.14A1.5,1.5,0,0,1,12,2.805ZM25.5,0H12A4.5,4.5,0,0,0,7.5,4.5v6.748L.765,15.3A1.409,1.409,0,0,0,0,16.5V34.564a7.5,7.5,0,0,0,7.5,7.422H34.65A7.5,7.5,0,0,0,42,34.564V16.5a1.409,1.409,0,0,0-.825-1.275L34.5,11.172v-.315a1.364,1.364,0,0,0-.345-1.29l-7.5-9A1.35,1.35,0,0,0,25.5,0Z"
                transform="translate(0 0)"
              ></path>
            </g>
          </svg>
          <div>
            <div v-if="language === 'ES'">
              <h5>Correo electrónico</h5>
            </div>
            <div v-else>
              <h5>Email</h5>
            </div>
            <address>
              <a class="text-white" href="mailto:contact@fronteracooper.com"
                >contact@fronteracooper.com</a
              >
            </address>
          </div>
        </div>

        <div class="footer__element">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 42.045 41.991"
            class="responsive-svg"
            width="10"
          >
            <g
              id="_14_-_Map_Location_1"
              data-name="14 - Map Location 1"
              transform="translate(0 0)"
            >
              <path
                id="Vector"
                d="M27,17.766a1.582,1.582,0,0,1,.929.218,1.65,1.65,0,0,1,.649.718,1.713,1.713,0,0,1,.145.969,1.69,1.69,0,0,1-.409.886,1.611,1.611,0,0,1-.822.5,1.576,1.576,0,0,1-.95-.065,1.628,1.628,0,0,1-.75-.6,1.7,1.7,0,0,1-.291-.934,1.666,1.666,0,0,1,.418-1.156A1.572,1.572,0,0,1,27,17.766Zm0-2.95a4.338,4.338,0,0,0-2.43.8,4.535,4.535,0,0,0-1.6,2.048,4.684,4.684,0,0,0-.234,2.616,4.6,4.6,0,0,0,1.207,2.314,4.388,4.388,0,0,0,2.247,1.243,4.306,4.306,0,0,0,2.54-.241,4.452,4.452,0,0,0,1.989-1.645,4.651,4.651,0,0,0,.777-2.5,4.705,4.705,0,0,0-1.318-3.277A4.435,4.435,0,0,0,27,14.816Zm0-1.761a5.965,5.965,0,0,1,2.381.47A6.111,6.111,0,0,1,31.4,14.911,6.321,6.321,0,0,1,32.735,17a6.468,6.468,0,0,1,.445,2.455,17.716,17.716,0,0,1-2.04,7.121,11.071,11.071,0,0,1-2.1,2.889,3.054,3.054,0,0,1-2.01.973,2.966,2.966,0,0,1-2-.973,11.071,11.071,0,0,1-2.1-2.889A17.478,17.478,0,0,1,20.9,19.45a6.451,6.451,0,0,1,.452-2.42,6.3,6.3,0,0,1,1.32-2.055A6.1,6.1,0,0,1,24.653,13.6,5.952,5.952,0,0,1,27,13.116ZM16.5,3.339l6.705,2.317A12.446,12.446,0,0,0,25.68,6.2v4.155a8.941,8.941,0,0,0-5.352,3.129,9.432,9.432,0,0,0-2.148,5.939,19.3,19.3,0,0,0,2.385,8.511,13.407,13.407,0,0,0,2.685,3.645,6.676,6.676,0,0,0,2.475,1.467v2.348a1.474,1.474,0,0,0,.106.55,1.44,1.44,0,0,0,.3.466,1.393,1.393,0,0,0,.453.311,1.358,1.358,0,0,0,1.068,0,1.393,1.393,0,0,0,.453-.311,1.44,1.44,0,0,0,.3-.466,1.474,1.474,0,0,0,.106-.55V33.043a6.467,6.467,0,0,0,2.475-1.467,13.451,13.451,0,0,0,2.7-3.645A19.478,19.478,0,0,0,36,19.45a9.434,9.434,0,0,0-2.134-5.967A8.942,8.942,0,0,0,28.5,10.336V6.212a12.478,12.478,0,0,0,2.475-.556l6.78-2.332a1.094,1.094,0,0,1,.538-.054,1.107,1.107,0,0,1,.5.211,1.151,1.151,0,0,1,.347.427,1.188,1.188,0,0,1,.114.544V32.858a3.7,3.7,0,0,1-.667,2.124A3.534,3.534,0,0,1,36.84,36.3L30,38.619a9.235,9.235,0,0,1-6,0L17.3,36.3a10.572,10.572,0,0,0-2.475-.525V7.973a1.459,1.459,0,0,0-.387-.98,1.378,1.378,0,0,0-.933-.442,1.346,1.346,0,0,0-.535.111,1.379,1.379,0,0,0-.451.316,1.426,1.426,0,0,0-.3.472,1.459,1.459,0,0,0-.1.553v27.8a11.217,11.217,0,0,0-2.52.633L4.23,38.527a.995.995,0,0,1-1.053-.051,1.042,1.042,0,0,1-.356-.428,1.078,1.078,0,0,1-.09-.556V9.116a3.938,3.938,0,0,1,.71-2.188,3.762,3.762,0,0,1,1.795-1.38l5.34-2.1A8.347,8.347,0,0,1,13.5,2.875a8.761,8.761,0,0,1,3,.463ZM13.5,0A10.993,10.993,0,0,0,9.6.759L4.23,2.813A6.572,6.572,0,0,0,1.16,5.285,6.876,6.876,0,0,0,0,9.116V37.492a4.127,4.127,0,0,0,.459,1.838,4,4,0,0,0,1.225,1.418,3.849,3.849,0,0,0,1.719.684,3.809,3.809,0,0,0,1.832-.2l5.34-2.07a8.638,8.638,0,0,1,5.925-.124l6.705,2.317a12.064,12.064,0,0,0,7.74,0l6.78-2.317a6.362,6.362,0,0,0,3.124-2.374,6.667,6.667,0,0,0,1.2-3.8V4.451a4.207,4.207,0,0,0-.45-1.844,4.077,4.077,0,0,0-1.208-1.438A3.928,3.928,0,0,0,38.681.445,3.88,3.88,0,0,0,36.84.589L30,2.922a9.235,9.235,0,0,1-6,0L17.34.6A11.171,11.171,0,0,0,13.5,0Z"
                transform="translate(0 0)"
              ></path>
            </g>
          </svg>
          <div>
            <div v-if="language === 'ES'">
              <h5>Ubicación</h5>
            </div>
           <div v-else>
            <h5>Location  </h5>
           </div>
            <address>Sonora, México</address>
          </div>
        </div>
      </v-row>
    </div>
  </footer>
</template>

<script setup>
import { getLanguage } from '@/kernel/utils';
import { ref } from 'vue';

const language = ref(getLanguage());

</script>

<style scoped>
#section__footer {
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("https://api3.cobredelmayo.com/api/public/img/bg-tbu.jpg") center/cover
      no-repeat;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: auto;
}

#section__footer .v-container {
  max-width: 100%;
  width: 100%;
  padding: 0;
}

#section__footer .v-row {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

#section__footer .v-col {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0; /* para evitar que crezca más de lo necesario */
}

#section__footer svg {
  width: 100%;
  max-width: 250px;
  height: auto;
}

.footer__element {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.responsive-svg path {
  fill: #ffffff;
}

@media (max-width: 768px) {
  #section__footer svg {
    max-width: 180px;
  }
  #section__footer {
    padding: 16px 24px 16px 24px;
  }
  #section__footer h5 {
    font-size: 14px;
  }
  #section__footer address {
    font-size: 12px;
  }
}
</style>
